export enum ShowType {
    NATIONAL_FINALS = 'national_finals',
    REGIONAL_FINALS = 'regional_finals',
    REGULAR_SEASON = 'regular_season',
    ZONE_FINALS = 'zone_finals'
}
